import { usePasarAFev } from '@/modules/bodega/usePasarAFev'

import estilos from './PaginaCartera.module.css'

/**
 * PASAR A FEV LO QUE ES SOLO SERVICIOS (0301).
 *
 * Mano de obra, grúa, certificaciones… no pasan por bodega. Con el IVA normal
 * van a FEV y Johan quiere que se pasen a mano, desde la orden o desde aquí.
 * La base solo lo deja si la cotización es solo servicios.
 */
export function PasarServiciosAFev({ cotizacionId }: { cotizacionId: string }) {
  const pasar = usePasarAFev()

  return (
    <>
      <button
        type="button"
        className={estilos.yaFevAbrir}
        onClick={() => pasar.mutate(cotizacionId)}
        disabled={pasar.isPending}
      >
        {pasar.isPending ? 'Pasando…' : 'Pasar a FEV'}
      </button>
      {pasar.error && <span className={estilos.yaFevError}>{pasar.error.message}</span>}
    </>
  )
}
